import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';

const StyledTitlePal = styled.h2`
  font-size: ${rem('15px')};
  margin-bottom: ${rem('10px')};
  text-transform: uppercase;
  display: flex;
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('16px')};
    margin-bottom: ${rem('14px')};
  `};
`;

const StyledProjects = styled.div`
  display: flex;
  min-height: ${rem('303px')};
  position: relative;
  width: 100%;
  ${mediaqueries.greaterThan('mobile')`
    min-height: ${rem('145px')};
    padding-top:0;
  `};
`;

const StyledNavigation = styled.ul`
  bottom: 0;
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  position: absolute;
  width: 100%;
  ${mediaqueries.greaterThan('mobile')`
    justify-content: flex-end;
  `};
`;

const StyledElements = styled.li`
  background-color: ${props => props.theme.colors.grayDarkest};
  cursor: pointer;
  margin-left: ${rem('5px')};
  opacity: 0.2;
  padding: ${rem('5px')};
  :before {
    content: none;
  }
  :hover {
    opacity: 1;
  }
  ${props =>
    props.activePage &&
    ` opacity: 1;
    `};
`;

const StyleEditIcon = styled(Icon)`
  margin-left: 15px;
  display: inline-block;
`;

export {
  StyledTitlePal,
  StyledProjects,
  StyledNavigation,
  StyledElements,
  StyleEditIcon
};
